import { CheckCircle } from "@mui/icons-material";
import { IconButton, Paper, Tooltip } from "@mui/material";
import { MaterialReactTable, MRT_ToggleDensePaddingButton, MRT_ToggleFiltersButton, MRT_ToggleFullScreenButton, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { dateTimeAccesor } from "../../../commons/table/columns/accesors";
import { localization, tableConfig } from "../../../commons/table/config/tableConfig";

const ProvidersResponseTable = ({
    handleOpenConfirmDialog,
    data,
    loading,
    rowSelection,
    setRowSelection,
}) => {
    const columns = useMemo(() => ([
        {
            header: "Art",
            accessorKey: "art",
        },
        {
            header: "Siniestro",
            accessorKey: "nroSiniestro",
        },
        {
            header: "Documento",
            accessorKey: "numeroDocumento",
        },
        {
            header: "Trabajador",
            accessorFn: (row) => `${row.apellidoTrabajador || ''}, ${row.nombreTrabajador || ''}`.trim(),
        },
        {
            header: "CUIT Prestador",
            accessorKey: "cuitPrestador",
        },
        {
            header: "Razón Social",
            accessorKey: "razonSocial",
        },
        {
            header: "Id Respuesta",
            accessorKey: "idRespuesta",
        },
        {
            header: "Nro Transacción",
            accessorKey: "nroTransaccion",
        },
        {
            header: "Nro Autorización",
            accessorKey: "nroAutorizacion",
        },
        {
            header: "Respuesta",
            accessorKey: "respuesta",
        },
        {
            header: "Fecha Hora Procesada",
            accessorKey: "fechaHoraProcesada",
            accessorFn: dateTimeAccesor("fechaHoraProcesada"),
            filterFn: "date",

        },
        {
            header: "Recepción Confirmada",
            accessorKey: "recepcionConfirmada",
            Cell: ({ cell }) => cell.getValue() ? "Sí" : "No",
        },
        {
            header: "Fecha Hora Confirmada",
            accessorKey: "fechaHoraConfirmada",
            accessorFn: dateTimeAccesor("fechaHoraConfirmada"),
            filterFn: "date",
        },
        {
            header: "Error",
            accessorKey: "error",
            Cell: ({ cell }) => cell.getValue() ? "Sí" : "No",
        }
    ]), []);

    const table = useMaterialReactTable({
        ...tableConfig,
        data: data || [],
        columns: columns,
        getRowId: (originalRow) => {
            return originalRow.idRespuesta?.toString()
        },
        state: { isLoading: loading, rowSelection },
        onRowSelectionChange: setRowSelection,
        enableSelectAll: true,
        enableRowSelection: true,
        enableColumnOrdering: false,
        renderToolbarInternalActions: ({ table }) => {
            return (
                <>
                    {table.getSelectedRowModel().rows.length > 0 && (
                        <Tooltip title="Reenviar Respuestas Seleccionadas">
                            <IconButton
                                sx={{ color: "secondary.main", marginLeft: 'auto' }}
                                onClick={() => handleOpenConfirmDialog()}
                            >
                                <CheckCircle />
                            </IconButton>
                        </Tooltip>
                    )}
                    <MRT_ToggleFiltersButton table={table} />
                    <MRT_ToggleDensePaddingButton table={table} />
                    <MRT_ToggleFullScreenButton table={table} />
                </>
            )
        },
        muiTableBodyCellProps: localization.cells,
        layoutMode: "grid",
    });

    return (
        <Paper sx={{ width: '100%' }}>
            <MaterialReactTable table={table} />
        </Paper>
    );
};

export default ProvidersResponseTable;
